/* eslint-disable no-case-declarations */
import { apiConstants } from "../../../constants/apiConstants"
import { backOfficeService } from "../../../services/backOfficeService"

// ** Initial State
const initialState = {
    liveReports: [],
}

export function backOffice(state = initialState, action) {
    switch (action.type) {
        case backOfficeService.getLiveReports.name + apiConstants._SUCCESS:
            let liveReports = []
            if (action.data?.meta?.current_page === 1) {
                liveReports = action.data?.live_reports
            } else {
                liveReports = state.liveReports?.concat(
                    action.data?.live_reports
                )
            }
            return {
                ...state,
                liveReports: liveReports,
            }
        default:
            return state
    }
}

export default backOffice
